import { useRouter } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { ArrowLeft, Home, Search } from 'lucide-react'

export function NotFound() {
  const router = useRouter()

  const handleGoHome = () => {
    router.navigate({ to: '/' })
  }

  const handleGoBack = () => {
    window.history.back()
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center space-y-8 p-8">
        {/* 404 Icon/Number */}
        <div className="space-y-4">
          <div className="text-6xl font-bold text-gray-300">404</div>
          <div className="text-2xl font-semibold text-gray-900">
            Sayfa Bulunamadı
          </div>
          <p className="text-gray-600">
            Aradığınız sayfa mevcut değil veya taşınmış olabilir.
          </p>
        </div>

        {/* Search-like illustration */}
        <div className="flex justify-center">
          <div className="p-4 bg-gray-100 rounded-full">
            <Search className="h-12 w-12 text-gray-400" />
          </div>
        </div>

        {/* Action buttons */}
        <div className="space-y-4">
          <Button 
            onClick={handleGoHome}
            className="w-full flex items-center justify-center space-x-2"
          >
            <Home className="h-4 w-4" />
            <span>Ana Sayfaya Dön</span>
          </Button>
          
          <Button 
            variant="outline"
            onClick={handleGoBack}
            className="w-full flex items-center justify-center space-x-2"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Geri Dön</span>
          </Button>
        </div>

        {/* Additional help text */}
        <div className="text-sm text-gray-500">
          <p>Eğer bu bir hata olduğunu düşünüyorsanız,</p>
          <p>lütfen sistem yöneticisine başvurun.</p>
        </div>
      </div>
    </div>
  )
}
